<div class="modal-header">
  <h4
    class="modal-title pull-left"
    i18n="@@move-bot-to-project"
  >Bot in Projekt verschieben</h4>
</div>
<div class="modal-body">
  <div class="card-body">
    <div class="row mb-1">
      <div class="col-3">
        <span i18n="@@project-colon">Projekt:</span>
      </div>
      <div class="col">
        <p-select
          [(ngModel)]="this.projectId"
          [options]="projects"
          optionValue="_id"
          fluid
        >
          <ng-template
            #selectedItem
            let-selectedProject
          >
            @if (selectedProject._id === '-'){
            {{ selectedProject | projectName }} (<span i18n="@@take-ownership">Besitz übernehmen</span>)
            } @else {
            {{ selectedProject | projectName }}
            }
          </ng-template>
          <ng-template
            #item
            let-project
          >
            @if (project._id === '-'){
            {{ project | projectName }} (<span i18n="@@take-ownership">Besitz übernehmen</span>)
            } @else {
            {{ project | projectName }}
            }
          </ng-template>
        </p-select>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <p-button
    type="button"
    severity="primary"
    label="Verschieben"
    [disabled]="(this.bot.projectId ?? '-') === this.projectId"
    (onClick)="this.moveToProject(this.projectId!)"
  ></p-button>
</div>